function SectionTitle(props) {
    return (
        <h2 className="section-title">{props.label}</h2>
    );
}

export default SectionTitle;